import { HelpTextMarkdown } from '@diagentech/exprworks-ui-components';
import React from 'react';

import {
  withCookieConsentMessageText,
  WithCookieConsentMessageTextProps,
} from '@/components/layout/AppCookieConsent/withCookieConsentMessageText';

interface CookieConsentMessageContentProps extends WithCookieConsentMessageTextProps {}

export const CookieConsentMessageContentComponent: React.FC<CookieConsentMessageContentProps> = ({ text }) => {
  return <HelpTextMarkdown id="cookie-consent-message" text={text} />;
};

export const CookieConsentMessageContent = withCookieConsentMessageText(CookieConsentMessageContentComponent);
